import type { ApiClient } from "@/common/api/http/types";

export interface ISocialLink {
  id?: string;
  social: string;
  active?: boolean;
}

interface ISocialLinksResponse {
  links: ISocialLink[];
}

export default class SocialLinksService {
  public constructor(private readonly client: ApiClient) {}

  async getSocialLinks(username: string): Promise<ISocialLink[]> {
    const response = await this.client.get<ISocialLinksResponse>(`v2/socials/${username}`);
    return response.links;
  }
}
